import { Link } from "react-router-dom";

const LINKS = [
  { label: "首页", to: "/" },
  { label: "电影分类", to: "/category/movie" },
  { label: "电视剧分类", to: "/category/tv" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

const SOCIALS = [
  { icon: "ri-weibo-fill", label: "微博", href: "#" },
  { icon: "ri-wechat-fill", label: "微信", href: "#" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩", href: "#" },
  { icon: "ri-douban-fill", label: "豆瓣", href: "#" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-50/80">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">天狼影院</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-50/70">
              专注电影与电视剧内容推荐，汇集最新影视资讯、影人动态与深度解读，帮你更快找到想看的那一部。
            </p>
            <div className="mt-5 flex items-center gap-2 text-sm">
              <span className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center">
                <i className="ri-mail-line text-background-50"></i>
              </span>
              <a href="mailto:contact@tianlang-cinema.com" className="hover:text-background-50 transition-colors">
                contact@tianlang-cinema.com
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="hover:text-accent-400 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">关注我们</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  className="w-10 h-10 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
            <p className="mt-5 text-xs leading-relaxed text-background-50/50">
              本站内容均为影视资讯与作品资料展示，不提供在线播放与下载服务。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-50/50">
          <p>© 2026 天狼影院 Tianlang Cinema. 保留所有权利。</p>
          <p>本站为演示性质的内容平台，影片信息仅供浏览参考。</p>
        </div>
      </div>
    </footer>
  );
}